import { render, staticRenderFns } from "./PerfilAcesso.vue?vue&type=template&id=eba4f2b4&"
import script from "./PerfilAcesso.vue?vue&type=script&lang=js&"
export * from "./PerfilAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports